import React from 'react';
import VipPassImg from "../../assets/images/Illustratn.svg";
import { Button, Grid, makeStyles } from "@material-ui/core";
import PlanView from "./PlanView";
import CouponIcon from "../../assets/images/Offer.svg";
import RemoveCouponIcon from "../../assets/images/ebookIcon.svg";
import { useTranslations } from "examsbook-react-sdk/custom-hooks";

const useStyles = makeStyles((theme) => ({
    margin: {
        marginTop: 10,
        marginBottom: 40,
    },
    payablePrice: {
        '& h4': {
            color: '#000',
            fontSize: 24,
            margin: 0,
            display: 'flex',
            alignItems: 'center',
        },
        '& div': {
            color: '#757575',
            fontSize: 12,
            paddingTop: 2,
        }
    },
    paymentBtn: {
        '& button': {
            backgroundColor: '#008C74',
            color: '#fff',
            fontSize: 14,
            fontWeight: 600,
            textTransform: 'unset',
            padding: '8px 20px',
            '&.Mui-disabled': {
                color: '#fff',
                backgroundColor: '#008c7487'
            },
            '&:hover': {
                backgroundColor: '#008C74',
            }
        }
    },
    discountedPrice: {
        color: '#757575',
        fontWeight: 400,
        fontSize: 13,
        position: 'relative',
        marginRight: 5,
        '&::before': {
            content: `''`,
            position: 'absolute',
            zIndex: 1,
            background: '#757575',
            height: 2,
            width: '100%',
            top: 6
        }
    },
    paymentFooter: {
        position: 'relative',
        bottom: 0,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        left: 0,
        zIndex: 9,
        '@media (max-width: 1024px)': {
            position: 'fixed'
        }
    },
    applyCouponBlock: {
        background: '#F7F5FF',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 20px',
        '& span': {
            display: 'flex',
            alignItems: 'center',
            fontSize: 12,
            color: '#747575',
            '& img': {
                width: 16,
                marginRight: 6
            }
        },
        '& p': {
            margin: 0,
            color: '#008C74',
            fontWeight: 'bold',
            fontSize: 14,
            cursor: 'pointer'
        }
    },
    vipPassImg: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        flexDirection: 'column',
        '& img': {
            height: 280,
            '@media (max-width: 767px)': {
                height: 220,
            },
        },
        '& h4': {
            margin: 0,
            fontSize: 20,
            color: '#4F4F4F',
            marginTop: -32,
            '@media (max-width: 767px)': {
                fontSize: 16,
            },
            '& span': {
                textTransform: 'uppercase',
                color: '#008C74',
                fontWeight: 600,
            },
        },
        '& p': {
            color: '#757575',
            fontSize: 16,
            margin: 0,
            paddingTop: 5,
            textAlign: 'center',
            lineHeight: '24px',
            '@media (max-width: 767px)': {
                fontSize: 13,
            },
        }
    },
    paymentMethod: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: '#fff',
        padding: '10px 20px',
    },
    removeCoupon: {
        textDecoration: 'underline'
    }
}));
const PlanSelectionView = props => {
    const {
        selectedCoupon,
        calculatedPlans,
        getDays,
        planCardClick,
        selectedPlan,
        makePayment,
        handleOpen,
        removeCoupon
    } = props;
    const t = useTranslations();
    const classes = useStyles();
    return (
        <>
            <div className={classes.vipPassImg}>
                <img src={VipPassImg} alt=""/>
                <h4>Examsbook <span>vip pass</span></h4>
                <p>Get unlimited Quizzes, Test, Mock Papers, and Much More!</p>
            </div>
            <Grid container spacing={3} className={classes.margin}>
                {calculatedPlans.map((plan, index) => (
                    <PlanView
                        key={index}
                        plan={plan}
                        planCardClick={planCardClick}
                        getDays={getDays}
                        selectedPlan={selectedPlan}/>
                ))}
            </Grid>
            <div className={classes.paymentFooter}>
                {
                    !(selectedCoupon && selectedCoupon.couponCode) ?
                        <>
                            {
                                selectedPlan && <div className={classes.applyCouponBlock}>
                                <span>
                                    <img src={CouponIcon} alt=""/>
                                    Get exciting offers inside
                                </span>
                                    <p onClick={handleOpen}>Apply Coupon</p>
                                </div>
                            }
                        </>
                        : <div className={classes.applyCouponBlock}>
                                <span>
                                    <img src={RemoveCouponIcon} alt=""/>
                                    {selectedCoupon.couponCode} (Coupon applied)
                                </span>
                            <p className={classes.removeCoupon} onClick={removeCoupon}>Remove</p>
                        </div>
                }
                <div className={classes.paymentMethod}>

                    <div className={classes.payablePrice}>
                        {selectedPlan && <>
                            <h4><span
                                className={classes.discountedPrice}>₹{selectedPlan.actualPrice}</span> ₹{selectedPlan.finalPrice}
                            </h4>
                            <div>Valid for {getDays(selectedPlan.subscriptionType)} Days</div>
                        </>
                        }
                    </div>
                    <div className={classes.paymentBtn}>
                        <Button onClick={makePayment}
                                disabled={!selectedPlan}>{t('Proceed_To_Payment')}</Button>
                    </div>
                </div>
            </div>
        </>
    );
};
export default PlanSelectionView;
